import { useSelectionManager } from "../../../SelectionManager"
import { SidepaneContainer } from "./components/SidepaneContainer"
import { SidepaneContent } from "./SidepaneContent"

export function Sidepane() {
  const selectionManager = useSelectionManager()

  return (
    <SidepaneContainer hasSelectedMedia={selectionManager.selectedCount !== 0}>
      <SidepaneContent />
    </SidepaneContainer>
  )
}
